import { render, staticRenderFns } from "./follow.vue?vue&type=template&id=0ea9dec3&scoped=true&"
import script from "./follow.vue?vue&type=script&lang=js&"
export * from "./follow.vue?vue&type=script&lang=js&"
import style0 from "./follow.vue?vue&type=style&index=0&id=0ea9dec3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea9dec3",
  null
  
)

export default component.exports